import {useEffect, useState} from 'react';

export default function DocxViewer({fileUrl}) {
    const [height, setHeight] = useState(0);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        // Chỉ chạy trên client
        setIsClient(true);

        const updateHeight = () => setHeight(window.innerHeight);
        updateHeight();

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    if (!isClient) return null; // Không render SSR

    const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;

    return (
        <iframe
            src={viewerUrl}
            width="100%"
            height={height} // chiếm full chiều cao window
            frameBorder="0"
            title="Office Viewer"
            style={{border: 'none', display: 'block', minHeight: '100vh'}}
        />
    );
}
